<script lang="ts">
import { type PropType, defineComponent } from 'vue'

/**
 * SidebarLink
 */
export default defineComponent({
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    route: {
      type: Object as PropType<{
        name: string
        hash?: string
        params?: Record<any, any>
        query?: Record<any, any>
      }>,
      required: true,
    },
  },
  emits: ['closeMenu'],
  computed: {
    activeLink() {
      const checkRouteName =
        this.$router.currentRoute.value.name === this.route.name

      if (this.route.hash) {
        return (
          checkRouteName &&
          this.$router.currentRoute.value.hash === this.route.hash
        )
      }

      if (this.route.query) {
        for (const [key, value] of Object.entries(this.route.query)) {
          if (this.$router.currentRoute.value.query[key] !== value) {
            return false
          }
        }

        return checkRouteName
      }

      return checkRouteName
    },
  },
})
</script>

<template>
  <RouterLink
    :to="route"
    class="flex h-full w-full gap-2 whitespace-nowrap rounded-md items-center p-3 hover:bg-primary/10 active:bg-primary/50"
    :class="{ 'route-link-active': activeLink }"
    :tabindex="0"
    @click="$emit('closeMenu')"
  >
    <slot name="icon" />

    <slot v-if="open" name="content" />
  </RouterLink>
</template>

<style lang="scss" scoped>
.route-link-active:not(.active):not(.hover) {
  @apply bg-primary/20 font-bold;
}
</style>
